import React from "react";
import '../css/photo.css';

export default function Video(props) {

    const showDate = props.showDate

    return (
        <div className="card video-container">
            <video controls>
                <source src={props.data.src} type="video/mp4" />
            </video>
            <p>{props.data.title}<br />
                {showDate && props.data.date}</p>
        </div>
    );
}
